import { EntityState } from '@ngrx/entity';
import { Client } from '../client/client.model';
import { clientfilecontent } from '../download-input-files/input-file.model';

export enum WorkQueueStatus {
  new = 'new',
  underreview = 'under review',
  complete = 'complete',
}

export class GridCriteriaModel {
  customizedSetting?: string;
  key: string;
  gridSetting: string;
}


export enum UserAction {
  completed = 'completed',
  notrequired = 'not required',
  assign = 'assign',
}
export class WorkQueueUpdateModel
{
  id: number;
  workqueuestatusid: number = -1; 
  workqueueaccountupdateoptionid: number = -1;
  workqueuecustomerfollowupoptionid: number = -1;
  workqueueinsurancefollowupoptionid: number = -1;
  workqueueinvestigationoptionid: number = -1;
  comments: string;
}

export class HistoryModel {
  accountUpdate?: string;
  addressFlag?: boolean;
  comment: string;
  customerFollowUp?: string;
  damagePost?: boolean;
  date: Date;
  debtorProvinceFlag?: boolean;
  deceasedFlag?: boolean;
  ebay?: boolean;
  eventDate?: string;
  exportFlag?: boolean;
  impound?: boolean;
  insuranceFollowUp?: string;
  insurancePost?: boolean;
  investigation?: string;
  jurisdiction?: string;
  mvrFlag?: boolean;
  nameFlag?: boolean;
  ncoaFlag?: boolean;
  nixieFlag?: boolean;
  odometerReadingFlag?: boolean;
  other?: boolean;
  pcoaFlag?: boolean;
  nameAmendmentStatus?: string;
  ppsaRegistrationStatus?: string;
  reportDate?: string;
  salvage?: boolean;
  status: string;
  stolen?: boolean;
  updatedInfoFlag: boolean;
  usMVRFlag?: boolean;
  usReadingFlag?: boolean;
  user: string;
}

export class HistoryInfoModel {
  confirmedMove: HistoryModel[];
  dailyMonitoring: HistoryModel[];
  lvsTrigger: HistoryModel[];
  potentialMove: HistoryModel[];
  usMove: HistoryModel[];
  vehiclePost: HistoryModel[];
}
export class QueueHistoryInfoModel {
  eventdatetime: Date;
  comments: string;
  currentvalue: string;
  previousvalue: string;
  currentqueue: number;
  previousqueue: number;
}

export class WorkQueueModel {
  id: number;
  lendercorporationcode: string;
  insurecorporationcode: string;
  policynumber: string;
  policyeffectivedate: Date;
  dwellingcoverage: number;
  sufficientinsurancecoverage: string;
  statusid: number;
  borrow1: string;
  borrow2: string;
  borrowersfirstname: string;
  borrowerslastname: string;
  coborrower1firstname: string;
  coborrower1lastname: string;
  coborrower2firstname: string;
  coborrower2lastname: string;
  coborrower3firstname: string;
  coborrower3lastname: string;

  lenderaddress: string;
  lendercity: string;
  lenderprovince: string;
  lenderpostalcode: string;
  appraisedvalueprincipalbalance: number;
  productaccountnumber: string;
  productaccountnomortgage: string;
  maturitydate: string;
  remainingamortization: number;
  lenderreslid: number;
  producttype: string;
  brand: string;
  hppholcindicator: string;
  borrowerlanguagepreference: string;
  rankofcharge: string;
  status: string;
  tbd: string;
  insureriplid: number;
  noticetypepolicy: string;
  insuredfirstname: string;
  insuredlastname: string;
  coinsured1firstname: string;
  coinsured1lastname: string;
  coinsured2firstname: string;
  coinsured2lastname: string;
  coinsured3firstname: string;
  coinsured3lastname: string;

  insureraddress: string;
  insurercity: string;
  insurerprovince: string;
  insurerpostalcode: string;

  fileid: number;
  lenderreslidstatusid: number;
  newpolicy: boolean;
  replacementpolicy: boolean;
  cancelpolicy: boolean;
  terminationpolicy: boolean;
  amendmentpolicy: boolean;
  policydatereceived: Date;
  policyremediationdate: Date;
  followupdate: Date;
  reason: string;
  insufficientamount: string;

  reportdate: Date;
  lastvieweddate: Date;
  fullmatch: string;
  partialmatch: string;
  nomatch: string;
  updatebyuser: string;
  mortgageprincipalbalance: string;
  totalreslprincipalbalance: string;
  lastcomments: string;
  resladvancedate: Date;
  helocprincipalbalance: number;
  queueHistoryDetails: QueueHistoryInfoModel[];

  workqueuestatusid: number = 1; 
  workqueueaccountupdateoptionid: number =-1;
  workqueuecustomerfollowupoptionid: number =-1;
  workqueueinsurancefollowupoptionid: number =-1;
  workqueueinvestigationoptionid: number = -1;
  updateflag: boolean;
}

export class LenderRESL {

  id: number;
  lendercorporation: Client;


  borrowersfirstname: string;

 
  borrowerslastname: string;

 
  coborrower1firstname: string;

 
  coborrower1lastname: string;

  coborrower2firstname: string;


  coborrower2lastname: string;

  coborrower3firstname: string;


  coborrower3lastname: string;

 
  propertyaddresslegaladdress: string;

 
  propertypostalcode: string;

  appraisedvalueprincipalbalance: number;

 
  productaccountnumber: string;

 
  producttype: string;

 
  brand: string;

 
  hppholcindicator: string;

 
  borrowerlanguagepreference: string;

 
  rankofcharge: string;

 
  status: string;

 
  maturitydate: string;

  remainingamortization: number;

 
  tbd: string;

  statusid: number;

  fileid: number;

  createdbyid: number;

  updatedbyid: number;
}
export class InsurerIPL {
  id: number;
  insurercorporation: Client;
  policynumber: string;
  policyeffectivedate: string;
  noticetypepolicy: string;
  insuredfirstname :string;
  insuredlastname :string;
  coinsured1firstname :string;
  coinsured1lastname :string;
  coinsured2firstname: string;
  coinsured2lastname: string;
  coinsured3firstname: string;
  coinsured3lastname: string;

  propertyaddresslegaladdress: string;
  propertypostalcode: string;
  dwellingcoverage: number;
  fileid: number;
  statusid: number;
}



export class WorkQueueDetails {
  id: number;
  queueType: number;
  allStatus: number;
  newStatus: number;
  underReviewStatus: number;
  completeStatus: number;
  accountUpdateStatus: number;
  customerfollowupStatus: number;
  insurancefollowupStatus: number;
  investigationStatus: number;

  workQueueModels: WorkQueueModel[];
}

export interface WorkQueueState extends EntityState<WorkQueueDetails> {
  selectedId: number | null;
  loading: boolean;
  loaded: boolean;
  error: string;
}

export interface QueuePages {
  displayName: string;
  id: number;
  iconName: string;
  isEnabled: boolean;
  isMenu: boolean;
  route: string;
}

export enum QueueName {
  LenderRemediation = 'Lender Remediation',
  LenderReconciliation = 'Lender Reconciliation',
  Watchlist = 'Watchlist',
}
